<template>
    <div>
        <h1 class="text-center mt-5">
            Tuskey
        </h1>

<!--
        <h5 class="text-center mt-3 mb-5">
            越境EC用外航貨物保険付きクーリエ発送ラベル作成サービス
        </h5>

        <div class="text-center mb-3">
            <p class="mb-1">サポートする越境EC</p>
            <b-img src="/images/icon_ebay.png" height="75" rounded></b-img>
            <b-img src="/images/icon_amazon.png" height="75" rounded></b-img>
            <b-img src="/images/icon_shopify.png" height="75" rounded></b-img>
        </div>

        <div class="text-center mb-3">
            <p class="mb-1">サポートするクーリエ</p>
            <b-img src="/images/icon_fedex.png" height="75" rounded></b-img>
            <b-img src="/images/icon_dhl.png" height="75" rounded></b-img>
            <b-img src="/images/icon_ups.png" height="75" rounded></b-img>
        </div>

        <b-card class="mt-5 mb-5">
            <b-card-text>
                <h3 class="text-center my-4">Tuskeyの特徴</h3>

                <h5>
                    <strong>新たな越境EC用外航貨物保険</strong>
                </h5>
                <p>
                    損害保険ジャパン株式会社と株式会社Cross Line Japanは、新たな損害保険を開発します。
                </p>
                <ul>
                    <li>１出荷あたりの保険料：1100円～</li>
                    <li>専用サイト：https://www.tuskey.one で発送ラベルを作るだけで完結。</li>
                </ul>

                <br>

                <h5>
                    <strong>Tuskeyで完結</strong>
                </h5>
                <p>
                    Tuskeyでクーリエ発送ラベルを作成していただき料金をお支払いいただくと
                    自動的に損害保険ジャパン株式会社を引受先とする外航貨物保険への加入が可能となります。
                    ユーザーは損害保険ジャパン株式会社への面倒な申請は不要です。
                    これにより2つの課題を解決します。
                </p>

                <br>
                <h5>
                    <strong>ユーザーアカウントでも、CLJアカウントでも発送ラベル作成可能</strong>
                </h5>
                <p>
                    Tuskeyではユーザー名義のクーリエ（FedEx、DHL、UPS）アカウントで発送ラベルを作成することも可能ですし、
                    クーリエアカウントを持っていないユーザーは株式会社Cross Line Japanのアカウント（FedEx、UPS）での発送ラベルの作成が可能です。
                </p>
            </b-card-text>
        </b-card>

        <b-card class="mt-3 mb-5">
            <b-card-text>
                <h3 class="text-center my-4">Tuskeyが解決する課題</h3>

                <h5>
                    <strong>課題①：高額なクーリエ提供の貨物保険</strong>
                </h5>
                <p>
                    越境EC（海外向けインターネット販売）で必須となる日本から海外への発送。
                    多くの販売者が大手3社クーリエ（FedEx、DHL、UPS）で発送していますが、販売者として高額だと常々感じてきました。
                    例えば、25万円の商品に対する各クーリエの保険料は2500～3000円です。
                </p>

                <br>

                <h5>
                    <strong>課題②：従来の外航貨物保険での煩雑な手続き</strong>
                </h5>
                <p>
                    また、保険会社が提供する外航貨物保険を利用しようとしても、
                    まずは基本契約を行い、保険会社が指定するエクセルなどで、定期的に対象の出荷データを提出する必要があります。
                    また、保険料も我々のような小規模事業者としては気軽に利用できるものではありませんでした。
                </p>
            </b-card-text>
        </b-card>
-->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    props: {
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'auth_uuid',
            'auth_email',
            'trans',
        ])
    },
    data() {
        return {
            error: {
            },
        }
    },
    mounted() {
        this.step1()
    },
    methods: {
        async fetch () {
        },
        step1 () {
            this.fetch().then(() => {
            })
            this.error = Object.assign({})
        },
    },
}
</script>

